// Source string for the widgets runtime IIFE — embedded into iframe srcdoc by composeWidgetDocument.
// The runtime must be pre-built via `npm run build:widgets-runtime` before the main app build runs.
import rawRuntime from "../../dist/widgets-runtime/widgets-runtime.js?raw";
export const widgetsRuntimeSource = rawRuntime;
